import React from "react";
import { CompletedTable } from "./view/CompletedTable";

interface Props {}

export const Completed: React.FC<Props> = () => {
  return (
    <>
      <CompletedTable />
    </>
  );
};
